import { TheMask, mask } from 'vue-the-mask'
export default {
	components: { /*Componentes utilizados*/ TheMask },
	directives: { mask },
	data() {//Declaracao de variaveis
		return {
			maskCEP: "##.###-###",
			maskCnpj: "##.###.###/####-##",
			maskCpf: "###.###.###-##",
			maskCelular: "+## (##) #####-####",
			maskTelefone: "(##) ####-####",
			maskRG: "##.###.###-##",
			maskData: "##/##/####",
			maskDocumentoIdentificacao: "##############",
			maskDocumentoIdentificacaoUpload: "XXXXXXXXXXXXXXXXXXXXXXXXXXXXXX",
			maskAlfaNumRG: 'XXXXXXXXXXXXXXXXXXXXXXXXX',
			maskNumSEI: "###.####.####.#######-##",
			maskAnyChar: {
				mask: '..............................',
				tokens: {
				  '.': {
					pattern: /./
				  }
				}
			  }
		}
	}
}
